module.exports = __webpack_public_path__ + "media/application/images/ipad@2x-067265bcc779d6897ff13a92101a3ee8.png";